import BaseTimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';

import cs from 'classnames';
import { useRecoilValue } from 'recoil';

import { ia } from 'lib/helpers/utility';
import { useWorkingHours } from 'lib/hooks/useWorkingHours';

import { currentPractice } from 'components/practice/practiceState';

import Icon from '../Icon/Icon';
import Popover from '../Popovers/Popover/Popover';

/**
 * @param {import('./lib/propTypes').TimePickerProps} props
 */

const TimePicker = (props) => {
  const {
    value,
    onChange = () => {},
    className,
    inputClassName,
    isOptions = true,
    timeOptions = []
  } = props;

  const currPractice = useRecoilValue(currentPractice);
  const workingHours = useWorkingHours(currPractice);

  const options = isOptions
    ? ia(timeOptions)
      ? timeOptions
      : workingHours.map((item) => ({ ...item, onClick: () => onChange(item.value) }))
    : [];

  const isCustom = ia(options);
  const isValue = Boolean(value);

  return (
    <Popover
      className={cs(
        isCustom &&
          'relative rounded-md border border-solid border-neutral-200 bg-white px-3 focus-within:border-primary-500 focus-within:outline focus-within:outline-2 focus-within:outline-[#CBF0FD]',
        className
      )}
      innerWrapperClassName="!static"
      panelClassName="w-full max-h-[350px] overflow-y-auto"
      customButton={
        <BaseTimePicker
          className={cs(isValue && 'filled', isCustom && 'is-options', inputClassName)}
          disableClock
          hourPlaceholder="hh"
          minutePlaceholder="mm"
          clearIcon={null}
          value={value}
          onChange={onChange}
        />
      }
      customButtonTrigger={
        isCustom && <Icon icon="arrow-square-down-mono" size={24} color="primary" shade={300} />
      }
      options={options}
    />
  );
};

export default TimePicker;
